import React, { useReducer } from 'react';
import { connect } from 'react-redux';
import reducer, { defaultState, updateFieldCreator, setEditDataCreator } from './reducer';
import {
  loadGlobalCisCertificateHoldersAttributesCreator,
  loadGlobalCisCertificatesAttributesCreator,
  setIpmaCisEditErrorsCreator,
  updateIpmaCisCreator,
  loadClientMemberAssociationsByCBCreator,
} from '../../../../../store/actionsCreators';
import EditUnknownImport from '../../../../../shared/Cis/UnknownImports/Edit/EditUnknownImport';

const EditUnknownImportIpma = ({
  unknownImport,
  errors,
  updateUnknownImport,
  removeError,
  levelDomains,
  certificationBodies,
  loadCertificatesAttributes,
  organisations,
  loadClientMemberAssociations,
  memberAssociations,
}) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  return (
    <EditUnknownImport
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      setEditDataCreator={setEditDataCreator}
      certificationBodies={certificationBodies}
      levelDomains={levelDomains}
      unknownImport={unknownImport}
      errors={errors}
      updateUnknownImport={updateUnknownImport}
      removeError={removeError}
      loadCertificatesAttributes={loadCertificatesAttributes}
      loadClientMemberAssociations={loadClientMemberAssociations}
      memberAssociations={memberAssociations}
      organisations={organisations}
    />
  );
};

const mapStateToProps = ({ ipma, globals }) => ({
  unknownImport: ipma.cis.unknownImports.profile,
  errors: ipma.cis.unknownImports.editErrors,
  certificationBodies: globals.cis.certificationBodies,
  levelDomains: globals.cis.levelDomains,
  organisations: globals.cis.organizations,
  memberAssociations: globals.cis.clientMemberAssociations,
});

const mapDispatchToProps = (dispatch) => ({
  updateUnknownImport: (id, payload, history) =>
    dispatch(updateIpmaCisCreator(id, 'unknownImports', payload, history)),
  removeError: (payload) => dispatch(setIpmaCisEditErrorsCreator('unknownImports', payload)),
  loadCertificatesAttributes: () => dispatch(loadGlobalCisCertificatesAttributesCreator()),
  loadCertificateHoldersAttributes: () =>
    dispatch(loadGlobalCisCertificateHoldersAttributesCreator()),
  loadClientMemberAssociations: (payload) =>
    dispatch(loadClientMemberAssociationsByCBCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditUnknownImportIpma);
